import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    VIEWER: {
        /** Accessible label for asset viewer toggle */
        ARIA_LABEL: string;
    };
    DETAILS: {
        /** Accessible label for asset info toggle */
        ARIA_LABEL: string;
    };
    AI: {
        /** Accessible label for AI panel toggle */
        ARIA_LABEL: string;
    };
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Asset viewer panel toggle labels */
            VIEWER: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        /** Accessible label for asset viewer toggle */
                        ARIA_LABEL: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "PanelToggles.VIEWER.ARIA_LABEL?c=18t1na8rqu2h6", defaultMessage: "Toggle the Asset Viewer" }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            },
            /** Asset info panel toggle labels */
            DETAILS: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        /** Accessible label for asset info toggle */
                        ARIA_LABEL: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "PanelToggles.DETAILS.ARIA_LABEL?c=3i6osgokkyzmy", defaultMessage: "Toggle the Asset Info" }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            },
            /** AI panel toggle labels */
            AI: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        /** Accessible label for AI panel toggle */
                        ARIA_LABEL: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "PanelToggles.AI.ARIA_LABEL?c=1umjiqoqq0dlm", defaultMessage: "Toggle the AI Panel" }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
